import { FC } from "react";
import { useTranslation } from "react-i18next";
import { getTheme } from "Store/MultiDomain/MultiDomain.selector";
import { Tag } from "antd";
import { Icon } from "Components/UI";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { useSelector } from "react-redux";
import { FooterButtons, MainWrapper, ModalContent } from "./styles";

export interface IBlockedParams {
  hasPermission: boolean;
  isBlocked: boolean;
  hasBlockedFolders: boolean;
  hasMultipleFiles: boolean;
}

interface IDownloadBloqueadosModal {
  visible: boolean;
  blockedParams: IBlockedParams;
  onConfirm: () => void;
  onClose: () => void;
}

const DownloadBloqueadosModal: FC<IDownloadBloqueadosModal> = ({
  visible,
  blockedParams,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation(['listagemArquivos', 'common']);
  const theme = useSelector(getTheme);

  const buttons = (
    <FooterButtons>
      <Button
        onClick={onClose}
        className="cancel-button"
      >
        {t('common:cancel')}
      </Button>
      <Button
        type="primary"
        onClick={onConfirm}
        className="confirm-button"
      >
        {t('listagemArquivos:download.doDownload')}
      </Button>
    </FooterButtons>
  );

  if (blockedParams.hasPermission) {
    return (
      <Modal
        title={t('common:attention')}
        width={487}
        visible={visible}
        onCancel={onClose}
        footerButtons={buttons}
      >
        <MainWrapper>
          <p>
            {blockedParams.hasMultipleFiles
              ? t('listagemArquivos:download.multipleFilesBlockedWarning')
              : t('listagemArquivos:download.singleFileBlockedWarning')
            }
          </p>
          <p>
            {t('listagemArquivos:download.confirmDownload')}
          </p>
        </MainWrapper>
      </Modal>
    )
  }

  return (
    <ModalContent>
      {blockedParams.isBlocked ? (
        <div className="contentBlockedWrapper">
          <Tag color={theme.colors.surface.onSurfaceVariant} className="tag">
            <Icon icon="cadeadoFechado" color="branco" customSize={9} />
            {t('listagemArquivos:download.fileBlocked')}
          </Tag>
          <h3 className="titleBlockedContent">
            {blockedParams.hasMultipleFiles
              ? t('listagemArquivos:download.filesBlockedTitle')
              : t('listagemArquivos:download.fileBlockedTitle')
            }
          </h3>
          <p>
            {blockedParams.hasMultipleFiles
              ? t('listagemArquivos:download.multipleFilesBlockedContent')
              : t('listagemArquivos:download.singleFileBlockedContent')
            }
          </p>
          <p>
            {blockedParams.hasMultipleFiles
              ? t('listagemArquivos:download.contactMultiple')
              : t('listagemArquivos:download.contactSingle')
            }
          </p>
          <button
            className="close"
            onClick={onClose}
          >
            {t('common:close')}
          </button>
        </div>
      ) : (
        <div className="contentWrapper">
          <h3 className="titleContent">
            {blockedParams.hasBlockedFolders
              ? t('listagemArquivos:download.multipleFolderUnavailable')
              : t('listagemArquivos:download.multipleFilesUnavailable')
            }
          </h3>
          <span className="textContent">
            {blockedParams.hasBlockedFolders
              ? t('listagemArquivos:download.multipleFolderUnavailableDesc')
              : t('listagemArquivos:download.multipleFilesUnavailableDesc')
            }
          </span>
          <button
            className="close"
            onClick={onClose}
          >
            {t('common:close')}
          </button>
        </div>
      )}
    </ModalContent>
  )
}

export default DownloadBloqueadosModal;
